module.exports = __webpack_public_path__ + "static/media/Designs.e47e0d91.png";